import { Status, Text } from "@chakra-ui/react";
function ObservationStatus({ status }: { status: "created" | "processing" | "completed" | "failed" }) {
  const statuses = {
    "created": {color: "orange", "label": "Created"},
    "processing": {color: "purple", "label": "Model Processing"},
    "completed": {color: "green", "label": "Model Complete"},
    "failed": {color: "red", "label": "Model Failed"},
  };

  return (
    <Status.Root
      colorPalette={statuses[status].color}
      px={2}
      gap={1}
      borderWidth={1}
      borderRadius={100}
      borderColor={`${statuses[status].color}.600`}
      size="sm"
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
    >
      <Status.Indicator />
      <Text hideFrom="sm" color={`${statuses[status].color}.600`}>
        {statuses[status].label.split(" ")[1] || statuses[status].label}
      </Text>
      <Text hideBelow="sm" color={`${statuses[status].color}.600`}>
        {statuses[status].label}
      </Text>
    </Status.Root>
  );
}

export default ObservationStatus;
